import * as ast from '@nomicfoundation/slang/ast';
import { NonterminalKind } from '@nomicfoundation/slang/cst';
import { SlangNode } from './SlangNode.js';
import { AbicoderPragma } from './AbicoderPragma.js';
import { ExperimentalPragma } from './ExperimentalPragma.js';
import { VersionPragma } from './VersionPragma.js';

import type { ParserOptions } from 'prettier';
import type { AstNode } from './types.d.ts';

function createNonterminalVariant(
  variant: ast.Pragma['variant'],
  options: ParserOptions<AstNode>
): Pragma['variant'] {
  if (variant instanceof ast.AbicoderPragma) {
    return new AbicoderPragma(variant);
  }
  if (variant instanceof ast.ExperimentalPragma) {
    return new ExperimentalPragma(variant, options);
  }
  if (variant instanceof ast.VersionPragma) {
    return new VersionPragma(variant);
  }
  const exhaustiveCheck: never = variant;
  return exhaustiveCheck;
}

export class Pragma extends SlangNode {
  readonly kind = NonterminalKind.Pragma;

  variant: AbicoderPragma | ExperimentalPragma | VersionPragma;

  constructor(ast: ast.Pragma, options: ParserOptions<AstNode>) {
    super(ast);

    this.variant = createNonterminalVariant(ast.variant, options);

    this.updateMetadata(this.variant);
  }
}
